import { render } from "./Details.vue?vue&type=template&id=200a8670&scoped=true"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"

import "./Details.vue?vue&type=style&index=0&id=200a8670&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-200a8670"

export default script